import {
	DELIVERED_SP_ORDER_ITEM_CREATE,
	DELIVERED_SP_ORDER_ITEM_CREATE_SUCCESS,
	DELIVERED_SP_ORDER_ITEM_CREATE_ERROR,
	DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED,
	DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED_SUCCESS,
	DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED_ERROR,
	DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM,
	DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM_SUCCESS,
	DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM_ERROR,
} from "../actions/deliveredSpOrderItems";
import Vue from "vue";
import DeliveredSpOrderItemsService from '@/services/deliveredSpOrderItems';

const state = {
	status: ''
};

const getters = {
};

const actions = {
	[DELIVERED_SP_ORDER_ITEM_CREATE]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.deliveredSpOrderItem.id,
			comment: data.deliveredSpOrderItem.comment
		}
		return new Promise((resolve, reject) => {
			commit(DELIVERED_SP_ORDER_ITEM_CREATE);
			DeliveredSpOrderItemsService.create(requestData)
				.then(data => {
					commit(DELIVERED_SP_ORDER_ITEM_CREATE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(DELIVERED_SP_ORDER_ITEM_CREATE_ERROR, error);
					reject(error);
				});
		});
	},
	[DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.spOrderId) {
			requestData.spOrderIdFilter = data.tableProps.inputFilter.spOrderId;
		}
		if (data.tableProps.debtOnly) {
			requestData.debtOnly = data.tableProps.debtOnly;
		}
		if (data.tableProps.inputFilter.catalogNumber) {
			requestData.catalogNumberFilter = data.tableProps.inputFilter.catalogNumber;
		}
		return new Promise((resolve, reject) => {
			commit(DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED);
			DeliveredSpOrderItemsService.listFiltered(requestData)
				.then(responseData => {
					commit(DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
	[DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM]: ({ commit, dispatch }, data) => {
		let requestData = {
			deliveredSpOrderItemId: data.deliveredSpOrderItemId,
			spOrderItemId: data.spOrderItemId
		}
		return new Promise((resolve, reject) => {
			commit(DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM);
			DeliveredSpOrderItemsService.connectWithSpOrderItem(requestData)
				.then(data => {
					commit(DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM_ERROR, error);
					reject(error);
				});
		});
	},
};

const mutations = {
	[DELIVERED_SP_ORDER_ITEM_CREATE]: state => {
		state.status = 'loading';
	},
	[DELIVERED_SP_ORDER_ITEM_CREATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[DELIVERED_SP_ORDER_ITEM_CREATE_ERROR]: state => {
		state.status = 'error';
	},
	[DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[DELIVERED_SP_ORDER_ITEMS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM]: state => {
		state.status = 'loading';
	},
	[DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[DELIVERED_SP_ORDER_ITEM_CONNECT_WITH_SP_ORDER_ITEM_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};